// import React, { useEffect, useState } from 'react';
// import {
// 	Box,
// 	Typography,
// 	Card,
// 	CardContent,
// 	useTheme,
// 	useMediaQuery,
// 	Stack,
// 	Divider,
// 	Grid,
// 	Link,
// } from '@mui/material';
// import { CalendarToday, KeyboardArrowRight } from '@mui/icons-material';
// import LocationPinIcon from '@mui/icons-material/LocationPin';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Navigation, Pagination } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import HomeSmallHeader from '../../../../../components/component/resused-component/HomeSmallHeader';
// import { upcommingEventsAPI } from '../../../../../services/api/UserAPI';

// interface Event {
// 	id: number;
// 	eventType: string;
// 	description: string;
// 	menuType: string;
// 	eventDate: string;
// 	address: string;
// 	locationLink: string;
// }

// const EventSlider: React.FC = () => {
// 	const theme = useTheme();
// 	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
// 	const [events, setEvents] = useState<Event[]>([]);

// 	// const events: Event[] = [
// 	// 	{
// 	// 		id: 1,
// 	// 		eventType: 'Wedding Reception',
// 	// 		description:
// 	// 			'Elegant wedding celebrations with customized themes and decorations to make your special day unforgettable.',
// 	// 		menuType: 'Wedding',
// 	// 		eventDate: '15 June 2023',
// 	// 		address: 'Ganaga kaliyana Mahal',
// 	// 		locationLink: 'https://g.co/kgs/6X54oPr',
// 	// 	},
// 	// 	{
// 	// 		id: 2,
// 	// 		eventType: 'Corporate Event',
// 	// 		description:
// 	// 			'Professional event planning for corporate gatherings, conferences, and team-building activities.',
// 	// 		menuType: 'Corporate',
// 	// 		eventDate: '22 July 2023',
// 	// 		address: 'Rajah Muthiah Hall',
// 	// 		locationLink: 'https://g.co/kgs/Vuw2nVb',
// 	// 	},
// 	// 	{
// 	// 		id: 3,
// 	// 		eventType: 'Birthday Celebration',
// 	// 		description:
// 	// 			'Custom birthday parties for all ages with unique themes and entertainment options.',
// 	// 		menuType: 'Private',
// 	// 		eventDate: '5 August 2023',
// 	// 		address: 'Rani Meyammai Hall',
// 	// 		locationLink: 'https://g.co/kgs/GwzvZxg',
// 	// 	},
// 	// ];

// 	useEffect(() => {
// 		const fetchData = async () => {
// 			try {
// 				const respons = await upcommingEventsAPI();
// 				if (respons.success) {
// 					setEvents(respons.data);
// 				} else {
// 					setEvents([]);
// 				}
// 			} catch (e) {
// 				console.log(e);
// 			}
// 		};
// 		fetchData();
// 	}, []);
// 	return (
// 		<Grid container spacing={0} sx={{ minHeight: '500px' }}>
// 			{/* Background Image */}
// 			<Grid
// 				size={{ xs: 12, sm: 12, md: 5 }}
// 				sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }}
// 			>
// 				<Box
// 					sx={{
// 						backgroundImage: `url('/events/Frame 1000004239.png')`,
// 						backgroundSize: 'cover',
// 						backgroundPosition: 'center',
// 						height: '100%',
// 						minHeight: '300px',
// 						position: 'relative',
// 					}}
// 				/>
// 			</Grid>

// 			{/* Event Content */}
// 			<Grid size={{ xs: 12, sm: 12, md: 7 }}>
// 				<Box
// 					sx={{
// 						py: 8,
// 						px: { xs: 2, md: 4 },
// 						backgroundColor: theme.palette.background.paper,
// 						height: '100%',
// 						display: 'flex',
// 						flexDirection: 'column',
// 						justifyContent: 'center',
// 					}}
// 				>
// 					<HomeSmallHeader text="Our Coming Events" />

// 					<Typography
// 						variant="subtitle1"
// 						sx={{
// 							textAlign: 'center',
// 							mb: 4,
// 						}}
// 					>
// 						{`Explore the exquisite events we've crafted for various functions and
// 						occasions.`}
// 					</Typography>

// 					<Swiper
// 						navigation={true}
// 						slidesPerView={isMobile ? 1 : 2}
// 						spaceBetween={20}
// 						className="mySwiper"
// 						style={{ width: '100%' }}
// 						autoplay={{
// 							delay: 3000,
// 							disableOnInteraction: false,
// 							pauseOnMouseEnter: true,
// 						}}
// 						pagination={{
// 							clickable: true,
// 						}}
// 						modules={[Autoplay, Pagination, Navigation]}
// 					>
// 						{events.map((event) => (
// 							<SwiperSlide key={event.id}>
// 								<Card
// 									sx={{
// 										width: '100%',
// 										minWidth: 280,
// 										border: '1px solid',
// 										borderColor: theme.palette.divider,
// 										borderRadius: 2,
// 										boxShadow: 'none',
// 										transition: 'transform 0.5s ease-in',
// 										'&:hover': {
// 											transform: 'translateY(-5px)',
// 											boxShadow: 1,
// 										},
// 										height: '350px',
// 									}}
// 								>
// 									<CardContent>
// 										<Typography
// 											gutterBottom
// 											variant="h6"
// 											component="h3"
// 											sx={{ fontWeight: 'bold' }}
// 										>
// 											{event.eventType}
// 										</Typography>
// 										<Typography
// 											variant="body2"
// 											color="text.secondary"
// 											sx={{ mb: 2 }}
// 										>
// 											{event.menuType}
// 										</Typography>
// 										<Typography
// 											variant="body1"
// 											sx={{
// 												display: '-webkit-box',
// 												WebkitLineClamp: 6,
// 												WebkitBoxOrient: 'vertical',
// 												overflow: 'hidden',
// 												textOverflow: 'ellipsis',
// 											}}
// 										>
// 											{event.description}
// 										</Typography>
// 										<Divider sx={{ my: 2 }} />
// 										<Stack
// 											direction="row"
// 											justifyContent="space-between"
// 											alignItems="center"
// 										>
// 											<Stack direction="column" spacing={1}>
// 												<Stack
// 													direction="row"
// 													spacing={0.5}
// 													alignItems="center"
// 												>
// 													<CalendarToday
// 														fontSize="small"
// 														color="primary"
// 													/>
// 													<Typography variant="body2">
// 														{new Date(event.eventDate)
// 															.toLocaleDateString('en-GB')
// 															.replace(/\//g, '/')}
// 													</Typography>
// 												</Stack>
// 												<Stack
// 													direction="row"
// 													spacing={0.5}
// 													alignItems="center"
// 												>
// 													<LocationPinIcon
// 														fontSize="small"
// 														color="primary"
// 													/>
// 													<Typography
// 														variant="body2"
// 														sx={{
// 															display: '-webkit-box',
// 															WebkitLineClamp: 1,
// 															WebkitBoxOrient: 'vertical',
// 															overflow: 'hidden',
// 															textOverflow: 'ellipsis',
// 														}}
// 													>
// 														{event.address}
// 													</Typography>
// 												</Stack>
// 											</Stack>
// 											<Stack
// 												direction="row"
// 												spacing={1}
// 												sx={{ cursor: 'pointer' }}
// 											>
// 												<Link
// 													variant="body2"
// 													color="primary"
// 													fontWeight={600}
// 													underline="hover"
// 												>
// 													<a
// 														href={event.locationLink}
// 														target="_blank"
// 														rel="noopener noreferrer"
// 														style={{ textDecoration: 'none' }}
// 													>
// 														View Map
// 													</a>
// 												</Link>
// 												<KeyboardArrowRight
// 													fontSize="small"
// 													color="primary"
// 												/>
// 											</Stack>
// 										</Stack>
// 									</CardContent>
// 								</Card>
// 							</SwiperSlide>
// 						))}
// 					</Swiper>
// 				</Box>
// 			</Grid>
// 		</Grid>
// 	);
// };

// export default EventSlider;
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
// ======================================================================================================================
import React, { useEffect, useState } from 'react';
import {
	Box,
	Typography,
	Card,
	CardContent,
	useTheme,
	useMediaQuery,
	Stack,
	Divider,
	Grid,
	Link,
	Tooltip,
} from '@mui/material';
import { CalendarToday, KeyboardArrowRight } from '@mui/icons-material';
import LocationPinIcon from '@mui/icons-material/LocationPin';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import HomeSmallHeader from '../../../../../components/component/resused-component/HomeSmallHeader';
import { upcommingEventsAPI } from '../../../../../services/api/UserAPI';

interface Event {
	id: number;
	eventType: string;
	description: string;
	menuType: string;
	eventDate: string;
	address: string;
	locationLink: string;
}

const EventSlider: React.FC = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [events, setEvents] = useState<Event[]>([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const respons = await upcommingEventsAPI();
				if (respons.success) {
					setEvents(respons.data);
				} else {
					setEvents([]);
				}
			} catch (e) {
				console.log(e);
			}
		};
		fetchData();
	}, []);

	return (
		<Grid container spacing={0} sx={{ minHeight: '500px' }}>
			{/* Background Image */}

			{/* Event Content */}
			<Grid size={{ xs: 12, sm: 12, md: 7 }}>
				<Box
					sx={{
						py: 8,
						px: { xs: 2, md: 4 },
						backgroundColor: theme.palette.background.paper,
						height: '100%',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
					}}
				>
					<HomeSmallHeader text="Our UpComing Events" />

					<Typography
						variant="subtitle1"
						sx={{
							textAlign: 'center',
							mb: 4,
						}}
					>
						{`Explore the exquisite events we've crafted for various functions and
						occasions.`}
					</Typography>

					{events.length === 0 ? (
						<Typography
							variant="h6"
							sx={{
								textAlign: 'center',
								color: 'text.secondary',
							}}
						>
							No upcoming events at the moment.
						</Typography>
					) : (
						<Swiper
							navigation={true}
							slidesPerView={isMobile ? 1 : 2}
							spaceBetween={20}
							className="mySwiper"
							style={{ width: '100%' }}
							autoplay={{
								delay: 3000,
								disableOnInteraction: false,
								pauseOnMouseEnter: true,
							}}
							pagination={{
								clickable: true,
							}}
							modules={[Autoplay, Pagination, Navigation]}
						>
							{events.map((event) => (
								<SwiperSlide key={event.id}>
									<Card
										sx={{
											width: '100%',
											minWidth: 280,
											border: '1px solid',
											borderColor: theme.palette.divider,
											borderRadius: 2,
											boxShadow: 'none',
											transition: 'transform 0.5s ease-in',
											'&:hover': {
												transform: 'translateY(-5px)',
												boxShadow: 1,
											},
											height: '350px',
										}}
									>
										<CardContent>
											<Typography
												gutterBottom
												variant="h6"
												component="h3"
												sx={{ fontWeight: 'bold' }}
											>
												{event.eventType}
											</Typography>
											<Typography
												variant="body2"
												color="text.secondary"
												sx={{ mb: 2 }}
											>
												{event.menuType}
											</Typography>
											<Typography
												variant="body1"
												sx={{
													display: '-webkit-box',
													WebkitLineClamp: 6,
													WebkitBoxOrient: 'vertical',
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													height: '150px',
												}}
											>
												{event.description}
											</Typography>
											<Divider sx={{ my: 2, border: '0.65px solid' }} />
											<Stack
												direction="row"
												justifyContent="space-between"
												alignItems="center"
											>
												<Stack direction="column" spacing={1}>
													<Stack
														direction="row"
														spacing={0.5}
														alignItems="center"
													>
														<CalendarToday
															fontSize="small"
															color="primary"
														/>
														<Typography variant="body2">
															{new Date(event.eventDate)
																.toLocaleDateString('en-GB')
																.replace(/\//g, '/')}
														</Typography>
													</Stack>
													<Stack
														direction="row"
														spacing={0.5}
														alignItems="center"
													>
														<LocationPinIcon
															fontSize="small"
															color="primary"
														/>
														<Tooltip title={event.address} followCursor>
															<Typography
																variant="body2"
																sx={{
																	width: {
																		xs: '100%',
																		md: '85%',
																	},
																	display: '-webkit-box',
																	WebkitLineClamp: 1,
																	WebkitBoxOrient: 'vertical',
																	overflow: 'hidden',
																	textOverflow: 'ellipsis',
																}}
															>
																{event.address}
															</Typography>
														</Tooltip>
													</Stack>
												</Stack>
												<Stack
													direction="row"
													spacing={1}
													sx={{ cursor: 'pointer' }}
												>
													<Link
														variant="body2"
														color="primary"
														fontWeight={600}
														underline="hover"
													>
														<a
															href={event.locationLink}
															target="_blank"
															rel="noopener noreferrer"
															style={{ textDecoration: 'none' }}
														>
															View Map
														</a>
													</Link>
													<KeyboardArrowRight
														fontSize="small"
														color="primary"
													/>
												</Stack>
											</Stack>
										</CardContent>
									</Card>
								</SwiperSlide>
							))}
						</Swiper>
					)}
				</Box>
			</Grid>
			<Grid
				size={{ xs: 12, sm: 12, md: 5 }}
				sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }}
			>
				<Box
					sx={{
						backgroundImage: `url('/events/Frame 1000004239.png')`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						height: '100%',
						minHeight: '300px',
						position: 'relative',
						transform: 'scaleX(-1)',
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default EventSlider;
